import { a as getUsersByEmail, g as get, L as LicenseCollection, I as InstallerCollection } from "../../../../chunks/firebase.js";
const load = async ({ locals, depends }) => {
  if (locals.user) {
    const deviceQuery = await getUsersByEmail(locals.user.email);
    const license = await get(LicenseCollection(), locals.user.email);
    const installer = await get(InstallerCollection(), locals.user.email);
    if (license.data) {
      const licenseIssuedOn = license.data.issuedOn || license.doc.createTime?.toDate();
      console.log(licenseIssuedOn);
      const devices = deviceQuery.docs.map((doc) => doc.data()?.id);
      let installerInfo = installer.data;
      if (installer.data?.cancelled) {
        installerInfo = void 0;
      }
      return {
        license: {
          ...license.data,
          issuedOn: licenseIssuedOn
        },
        installer: installerInfo,
        devices
      };
    }
  }
  return {};
};
export {
  load
};
